import Vue from 'vue';

const toasts = [];
const eventBus = new Vue();

function addToast(options) {
  const id = `toast-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const toast = {
    id,
    variant: options.variant || 'information',
    title: options.title || '',
    message: options.message || '',
    actions: options.actions || [],
    timeout: 20000
  };

  toasts.push(toast);
  eventBus.$emit('toasts-changed');

  // O fechamento é controlado pelo componente ToastItem (com pausa no hover)

  return id;
}

function removeToast(id) {
  const index = toasts.findIndex((t) => t.id === id);

  if (index === -1) return;

  toasts.splice(index, 1);
  eventBus.$emit('toasts-changed');
}

const toastApi = {
  success(message, options = {}) {
    return addToast({
      variant: 'success',
      title: options.title || 'Sucesso',
      message: typeof message === 'string' ? message : options.message || '',
      actions: options.actions
    });
  },
  error(message, options = {}) {
    return addToast({
      variant: 'error',
      title: options.title || 'Atenção',
      message: typeof message === 'string' ? message : options.message || '',
      actions: options.actions
    });
  },
  warning(message, options = {}) {
    return addToast({
      variant: 'warning',
      title: options.title || 'Aviso',
      message: typeof message === 'string' ? message : options.message || '',
      actions: options.actions
    });
  },
  information(message, options = {}) {
    return addToast({
      variant: 'information',
      title: options.title || 'Informação',
      message: typeof message === 'string' ? message : options.message || '',
      actions: options.actions
    });
  },
  add(options) {
    return addToast(options);
  },
  remove: removeToast,
  getToasts: () => [...toasts],
  eventBus
};

export default {
  install(Vue) {
    Vue.prototype.$toast = toastApi;
  }
};

export { toastApi, eventBus as toastEventBus };
